import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

const getResponseType = (type: any) => {
  if (/xml|html|opf|xhtml|smil]/.test(type)) {
    return 'document';
  }
  if (/json/.test(type)) {
    return 'json';
  }
  return 'text';
};

let cachedBasePath: string | null = null;

export const fileRequestHandlerWithCapacitor = async (url: string, type: string) => {
  if (!cachedBasePath) {
    const baseUri = await Filesystem.getUri({ path: '', directory: Directory.Data });
    cachedBasePath = Capacitor.convertFileSrc(baseUri.uri);
  }
  const capRelativePath = url.substring(cachedBasePath.length);
  const contentType = type || getResponseType(url.substring(url.lastIndexOf('.')));
  const response = await Filesystem.readFile({
    path: capRelativePath,
    directory: Directory.Data,
    encoding: Encoding.UTF8,
  });
  const fileContent = response.data as string;

  if (contentType === 'document') {
    const doc = new DOMParser().parseFromString(fileContent.trim(), 'text/xml');
    // Check for parsing errors
    const parseError = doc.getElementsByTagName('parsererror');
    if (parseError.length) {
      console.error('Error parsing XML:', doc.documentElement.textContent);
      throw new Error('Error parsing XML.');
    }
    return doc;
  }
  if (contentType === 'json') {
    return JSON.parse(fileContent);
  }

  return response.data;
};
